import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { ConsolidateIcon, DownloadIcon } from '@/assets/icons/v2';

import { ConsolidateButton, DownloadButton } from './styles';

const ACTIONS_GUTTER = 24;

interface ActionsProps {
	consolidated: boolean;
	downloading: boolean;
	consolidating: boolean;
	onDownload: () => void;
	onToggleConsolidate: () => void;
}

export function Actions({
	consolidated,
	downloading,
	consolidating,
	onDownload,
	onToggleConsolidate
}: Readonly<ActionsProps>): JSX.Element {
	let consolidateLabel = I18n.get('Consolidate report');

	if (consolidated) {
		consolidateLabel = I18n.get('Deconsolidate');
	}

	return (
		<Row justify="end" gutter={[ACTIONS_GUTTER, 0]}>
			<Col>
				<DownloadButton icon={<DownloadIcon />} loading={downloading} onClick={onDownload}>
					{I18n.get('Download PDF')}
				</DownloadButton>
			</Col>
			<Col>
				<ConsolidateButton icon={<ConsolidateIcon />} loading={consolidating} onClick={onToggleConsolidate}>
					{consolidateLabel}
				</ConsolidateButton>
			</Col>
		</Row>
	);
}
